<template>
  <div>
    <el-row class="main" type="flex" justify="space-between">
      <!-- <div  :class="dialogVisible?'mid1':'mid'">
         
      </div> -->

      <el-dialog
           title=""
           style="width:100%;height:100%"
           :visible.sync="dialogVisible"
      >
      <videoR
            v-if="dialogVisible"
                                    :address="bigUrl"
                                    :id="'b'+bigUrl.substring(bigUrl.length - 6)+Math.ceil(Math.random()*10000000)"
                                    height="470px"
                            />
      <!-- <span slot="footer" class="dialog-footer">
         <el-button @click="dialogVisible = false">取 消</el-button>
     </span> -->
    </el-dialog> 
    
      <!-- 中间地图 -->
      <el-col style="flex:1" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">
        <div class="mapdiv">
          <div class="mapbox">
            <!-- 地图组件 -->
            <CesiumViewer ref="CesiumViewer" :roletype="cesiumType"  @click_ip="click_ip"/>
            <div
              @mousedown.prevent.stop.self="move"
              class="humanbox"
              v-show="userMsgBox"
              style="top: 44px;right: 10px;"
            >
              <div @click="closeUserBox" class="naav iconfont icon-guanbi" style></div>
              <div class="bodyBox">
                <div>所在楼栋:{{ floatuserMsgBox.sectionName }}</div>
                <div>单元:{{ floatuserMsgBox.cellNum }}单元</div>
                <div>门牌号:{{ floatuserMsgBox.doorCode }}</div>
              </div>
              <!-- <div></div> -->
            </div>

            <!-- 左边三个框 -->
            <!-- <div class="leftCard" v-if="personShow" v-show="this.$route.path != '/griddingindex'"> -->
              <!-- 最上盒子 -->
              <!-- <div class="lCardBox1" style="left:0px;top:0px" @mousedown="move">
                <div class="lc1Nav">
                  <span>{{currentLabel}}</span>
                  <span style="margin-left:30px;">当前数据 &nbsp;&nbsp;({{this.pageConfig.total}})</span>
                </div>
                <div class="line"></div>
                <div class="search-list">
                  <el-input
                    size="mini"
                    :placeholder="getPlaceholder"
                    v-model="findPerson.personName"
                  ></el-input>
                  <el-button size="mini" type="primary" @click="queryList">查询</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="downloadExcel"
                  >导出</el-button>
                  <el-button size="mini" type="primary" @click="moreIdCode">更多</el-button>
                </div>
                <div class="search-list" v-if="idCodeShow">
                  <span style="width: 30%;line-height: 30px;">身份证号</span>
                  <el-input
                          size="mini"
                          :placeholder="getPlaceholder"
                          v-model="findPerson.idCode"
                  ></el-input>
                </div>
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column key="1" prop="index" label="序号" :width="tableData.length?50:''"></el-table-column>
                  <el-table-column
                    prop="personName"
                    label="姓名"
                    key="2"
                    v-if=" currentId != '12' && currentId != '13' && currentId != '14'"
                  ></el-table-column>
                  <el-table-column
                    key="3"
                    prop="sexType"
                    label="性别"
                    v-if="currentId != '12' && currentId != '13' && currentId != '14'"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.sexType == '0'">男</span>
                      <span v-if="scope.row.sexType == '1'">女</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="familyCode"
                    label="门牌号"
                    key="4"
                    v-if="currentId != '12' && currentId != '13' && currentId != '14'"
                  >
                    <template slot-scope="scope">
                      <span>{{scope.row.familyCode ? scope.row.familyCode.split("_")[1]+'_'+scope.row.familyCode.split("_")[2]:''}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="gridName"
                    label="网格名"
                    show-overflow-tooltip
                    key="5"
                    v-if="currentId == '12' || currentId == '13'"
                  ></el-table-column>
                  <el-table-column
                    prop="blockName"
                    label="小区名"
                    show-overflow-tooltip
                    key="6"
                    v-if="currentId == '12' || currentId == '13'"
                  ></el-table-column>
                  <el-table-column
                    prop="sectionName"
                    label="名称"
                    show-overflow-tooltip
                    key="7"
                    v-if="currentId == '12' || currentId == '13'"
                  ></el-table-column>
                  <el-table-column
                    prop="lawPerson"
                    label="法人"
                    show-overflow-tooltip
                    key="8"
                    v-if="currentId == '14'"
                  ></el-table-column>
                  <el-table-column
                    prop="companyName"
                    label="企业名称"
                    show-overflow-tooltip
                    key="9"
                    v-if="currentId == '14'"
                  ></el-table-column>
                  <el-table-column
                    prop="doorCode"
                    label="门牌号"
                    show-overflow-tooltip
                    key="10"
                    v-if="currentId == '14'"
                  ></el-table-column>
                  <el-table-column key="8" prop="opt" label="定位" width="60px">
                    <template slot-scope="scope">
                      <i
                        class="el-icon-location-outline"
                        style="cursor:pointer;"
                        @click="openLocation(scope.row.sectionMapId.replace('buildclick',''))"
                      ></i>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  small
                  @current-change="handleCurrentChange"
                  :current-page.sync="pageConfig.currentPage"
                  layout="prev, pager, next"
                  :total="pageConfig.total"
                ></el-pagination>
              </div> -->

            <!-- </div> -->
            <!--              关闭按钮-->
            <!-- <div class="clearLeftCard" @click="clearLeft"  :class="personShow?'leftCard1':'leftCard2'" v-show="this.$route.path != '/griddingindex'">
            </div> -->
          </div>
        </div>
      </el-col>
    </el-row>
    
    <newBuildMsgDialog />
  </div>
</template>

<script>
import request from "../../../utils/request.js";
import CesiumViewer from "../../../components/cesiumContainer";
import newBuildMsgDialog from "./griddingModule/griddailog";
import { post } from "@/api/requrestHttp";
import { getDaochuInform, changeInfor, downloadPartyExcel } from "@/api/api";
import request2 from "../../../utils/request2";
import videoR from "@/components/videoRtmp";
export default {
  components: { CesiumViewer, newBuildMsgDialog ,videoR},
  data() {
    return {
      dialogVisible:false,
      path:this.$route.path,
      leftCardLeft:'350px',
      bigUrl:'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test22',
      routeName: "",
      nav2List: [
        {
          id: "11",
          label: "人员信息"
        },
        {
          id: "12",
          label: "楼栋库"
        },
        {
          id: "13",
          label: "危房信息"
        },
        {
          id: "14",
          label: "企业库"
        },
        {
          id: "32",
          label: "党员"
        }
      ],
      nav2List2: [
        // {
        //   id: "15",
        //   label: "未成年人"
        // },
        // {
        //   id: "16",
        //   label: "孕妇"
        // },
        // {
        //   id: "18",
        //   label: "残疾人"
        // },
        // {
        //   id: "19",
        //   label: "老年人"
        // }
        {
          id: "33",
          label: "刑满释放"
        },{
          id: "34",
          label: "社区矫正"
        },{
          id: "35",
          label: "重点青少年"
        },{
          id: "36",
          label: "吸毒人员"
        },{
          id: "37",
          label: "艾滋病"
        },{
          id: "38",
          label: "精神病"
        },
      ],
      nav2List3: [
        {
          id: "20",
          label: "3~6岁 幼儿园"
        },
        {
          id: "21",
          label: "7~12岁 小学"
        },
        {
          id: "22",
          label: "13~16岁 初中"
        },
        {
          id: "23",
          label: "17~19岁 高中"
        }
      ],
      nav2List4: [
        {
          id: "24",
          label: "上访人员"
        },
        {
          id: "25",
          label: "低保人员"
        },
        {
          id: "26",
          label: "空巢老人"
        },
        {
          id: "27",
          label: "残疾人员"
        },
        {
          id: "28",
          label: "失独人员"
        },
        {
          id: "29",
          label: "孤寡老人"
        },
        {
          id: "30",
          label: "优抚人员"
        },
        {
          id: "31",
          label: "退役军人"
        },
      ],
      more: false,
      cesiumType: "all",
      loading: false,
      userMsgBox: false,
      floatuserMsgBox: {},
      // 判断地图颜色是否显示
      color: true,
      // 区域id
      quyuID: 0,
      personShow: true,
      pageConfig: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      findPerson: {
        orgId: "",
        characteristic: "",
        sexType: "",
        personName: "",
        idCode:''
      },
      idCodeShow:false,
      tableData: [],
      currentId: "",
      currentLabel: "",
      fileName: "信息表",
      gridCode: ""
    };
  },
  computed: {
    getPlaceholder() {
      let placeholderText = "请输入人员名称";
      if(this.currentId==12 || this.currentId==13){
        placeholderText='请输入楼栋名称';
      }
      if(this.currentId==14){
        placeholderText='请输入企业名称';
      }

      return placeholderText;
    },
    // 查询
    getApiUrl() {
      let url = "";
      if (this.currentId == "12" || this.currentId == "13") {
        url = "/djyl/admin/section/info/findSection";
      } else if (this.currentId == "14") {
        url = "admin/enterprise/info/list";
      } else {
        url = "/djyl//admin/person/info/findPagePerson";
      }
      return url;
    },
    // 导出
    getApiUrlDaochu() {
      let url = "";
      if (this.currentId == "12" || this.currentId == "13") {
        url = "/admin/section/info/export";
      } 
      else if (this.currentId == "14") {
        url = "admin/enterprise/info/export";
      }
       else {
        url = "/admin/person/info/downloadPersonExcel";
      }
      return url;
    },
    getParams() {
      let params = {
        pageSize: this.pageConfig.pageSize,
        pageNo: this.pageConfig.currentPage
      };
      let buildParams = {
        sectionName: this.findPerson.personName,
        gridCode: this.gridCode
      };
      if (this.currentId == "11") {
        params = { ...params, ...this.findPerson ,};
      } else if (this.currentId == "12") {
        params = { ...params, ...buildParams };
      } else if (this.currentId == "13") {
        //alert(123)
        params = { ...params, isDanger: '1', ...buildParams };
      } else if (this.currentId == "14") {
        params = { ...params };
      } else if (this.currentId == "15") {
        params = { ...params,  underAge: 1, ...this.findPerson };
      } else if (this.currentId == "16") {
        params = { ...params,  woman: 0, ...this.findPerson };
      } else if (this.currentId == "17") {
        params = { ...params  };
      } else if (this.currentId == "18") {
        params = { ...params, disabilityPerson: '0', ...this.findPerson };
      } else if (this.currentId == "19") {
        params = { ...params,  oldAge: '1', ...this.findPerson };
      } else if (this.currentId == "20") {
        params = { ...params,  startAge: '3', endAge: '6', ...this.findPerson };
      } else if (this.currentId == "21") {
        params = { ...params, startAge: '7', endAge: '12', ...this.findPerson };
      } else if (this.currentId == "22") {
        params = { ...params,  startAge: '13', endAge: '16', ...this.findPerson };
      } else if (this.currentId == "23") {
        params = { ...params,  startAge: '17', endAge: '19', ...this.findPerson };
      }else if (this.currentId == "24") {
        params = { ...params, petition: 0, ...this.findPerson };
      }else if (this.currentId == "25") {
        params = { ...params,  guaranteePerson: 0, ...this.findPerson };
      }else if (this.currentId == "26") {
        params = { ...params,  absentParent: 0, ...this.findPerson };
      }else if (this.currentId == "27") {
        params = { ...params, disabilityPerson: 0, ...this.findPerson };
      }else if (this.currentId == "28") {
        params = { ...params,  oldPerson: 0, ...this.findPerson };
      }else if (this.currentId == "29") {
        params = { ...params,  nooldPerson: 0, ...this.findPerson };
      }else if (this.currentId == "30") {
        params = { ...params,  helpPerson: 0, ...this.findPerson };
      }else if (this.currentId == "31") {
        params = { ...params,  retireSoldier: 0, ...this.findPerson };
      }else if (this.currentId == "32") {
        params = { ...params,  partyType: 0, ...this.findPerson };
      }else if (this.currentId == "33") {
        params = { ...params,  rele: 0, ...this.findPerson };
      }else if (this.currentId == "34") {
        params = { ...params, correct: 0, ...this.findPerson };
      }else if (this.currentId == "35") {
        params = { ...params, teenagers: 0, ...this.findPerson };
      }else if (this.currentId == "36") {
        params = { ...params,  drug: 0, ...this.findPerson };
      }else if (this.currentId == "37") {
        params = { ...params,  adis: 0, ...this.findPerson };
      }else if (this.currentId == "38") {
        params = { ...params,  spirit: 0, ...this.findPerson };
      }else {
        params = { ...params, ...this.findPerson };
      }
      return params;
    }
  },
  watch: {
    currentId(newVal, oldVal) {
      if (oldVal != newVal) {
        this.pageConfig.currentPage = 1;
        this.findPerson.personName = "";
        this.pageConfig.total = 0;
        this.tableData = [];
      }
    },
    $route: {
      handler: function(val, oldVal){
        if(val.path=='/gridsidebar1'){
          this.currentId = this.nav2List[0].id;
          this.currentLabel = this.nav2List[0].label;
        }
        if(val.path=='/gridsidebar2'){
          this.currentId = this.nav2List2[0].id;
          this.currentLabel = this.nav2List2[0].label;
        }
        if(val.path=='/gridsidebar3'){
          this.currentId = this.nav2List3[0].id;
          this.currentLabel = this.nav2List3[0].label;
        }
        if(val.path=='/gridsidebar4'){
          this.currentId = this.nav2List4[0].id;
          this.currentLabel = this.nav2List4[0].label;
        }
        this.personShow = true;
        this.queryList();
        console.log(val);
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
    // console.log(this.path)
    // if(this.path.name=='griddingindex'){
    //   this.personShow = false;
    // }
    // 点击楼栋时,开启加载等待,防止多次点击
    this.$Bus.$on("buildtrue", data => {
      this.loading = data;
    });
    // ? 侧边栏定位时,打开小窗口信息
    this.$Bus.$on("locationid", data => {
      this.getUserBoxMsg(data);
    });
    this.queryList();
    this.getModel();
  },

  beforeDestroy() {
    // 页面销毁前 取消所有事件总线的监听
    this.$Bus.$off();
  },
  methods: {
    //
    click_ip(e){
      console.log('我需要的值',e)
      this.dialogVisible= false
      let id = e
            if(id=='192.168.1.22'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test22';
            }else if(id=='192.168.1.6'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test06';
            }else if(id=='192.168.1.11'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test11';
            }else if(id=='192.168.1.12'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test12';
            }else if(id=='192.168.1.7'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test10';
            }else if(id=='192.168.1.10'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test07';
            }else if(id=='xxx001'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test05';
            }else if(id=='192.168.1.17'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test17';
            }else if(id=='192.168.1.5'){
                this.bigUrl = 'rtmp://zdsq.qmkjzh.com:1935/oflaDemo/test08';
            }
          console.log('this.bigUrl',this.bigUrl)
      setTimeout(()=>{
                this.dialogVisible=true;
      }, 500);
    },
    //获取人员信息
    getModel(){
      if(this.path == '/gridsidebar1'){
        post("/djyl/admin/person/info/findPagePerson", {
          pageNo:this.pageConfig.currentPage,
          pageSize: this.pageConfig.pageSize,
        }).then(res => {
          console.log(res);
          if(res.code == 200){
            if(res.content){
              let data = res.content.list;
              if (data && data.length > 0) {
                data.map((item, index) => {
                  item.index =
                          (this.pageConfig.currentPage - 1) * this.pageConfig.pageSize +
                          (parseInt(index) + 1);
                });
                this.tableData = data;
                this.pageConfig.total = res.content.count;
              }
            }else {
              this.tableData = [];
              this.pageConfig.total=0;
            }

            // this.tableData = res.content.list
          }else {
            this.$message.error(res.message);
          }
        });
      }

    },
    clearLeft(){
      if(this.personShow){
        this.personShow=false;

      }else {
        this.personShow=true;
      }
    },
    humenmsg(id, label) {
      if (id) {
        this.currentId = id;
        this.currentLabel = label;
        this.fileName = label;
        this.personShow = true;
        this.queryList();
      } else {
        this.personShow = false;
      }
    },
    moreSearch() {
      //console.log(123);
      this.domains.push({
        value: ""
      });
    },
    closeUserBox() {
      this.userMsgBox = false;
    },
    async getUserBoxMsg(data) {
      let formData = new FormData();
      formData.append("familyCode", data);
      let result = await this.$http.post(
        "/admin/family/info/getFamilyByCode",
        formData
      );
      this.floatuserMsgBox = result.data.content;

      this.userMsgBox = true;
    },
    // 人员信息
    queryList() {
      let url = this.getApiUrl;
      let params = this.getParams;
      console.log(params);
      if (!url) return;
      this.$http.post(url, params).then(resp => {
        const { code, content, message } = resp;
        if (code == 200) {
          // console.log(content);
          let arr = Object.keys(content);
          console.log(arr);
          if(!arr.length){
            console.log("!content",content);
            this.tableData = [];
            this.pageConfig.total = 0;

          }else {
            console.log("content",content);
            let data = content.list;
            if (data && data.length > 0) {
              data.map((item, index) => {
                item.index =
                        (this.pageConfig.currentPage - 1) * this.pageConfig.pageSize +
                        (parseInt(index) + 1);
              });
              this.tableData = data;
              this.pageConfig.total = content.count;
            }
          }

        } else {
          this.$message.warning(message);
        }
      });
    },
    //更多
    moreIdCode(){
      if(this.idCodeShow){
        this.idCodeShow=false;
      }else {
        this.idCodeShow=true;
      }
    },
    //人员导出
    // downloadExcel() {
      // post("/admin/person/info/downloadPersonExcel", {
      //
      // }).then(res => {
      //   console.log(res)
      // });
    // },
    //导出excelgetApiUrlDaochu
    async downloadExcel() {
      var res = await request2({
        url: this.getApiUrlDaochu,
        method: "POST",
        data: this.getParams,
        responseType: "blob"
      });
      console.log(res);
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      console.log(this.getApiUrlDaochu);
      if(this.currentId == '12') {
        var fileName = "楼栋库信息表.xls";
      }else if (this.currentId == "13") {
        var fileName = "危房信息表.xls";
      }else if (this.currentId == "14") {
        var fileName = "企业库信息表.xls";
      }else if (this.currentId == "32")  {
        var fileName = "党员信息表.xls";
      }else if (this.currentId == "11")  {
        var fileName = "人员信息表.xls";
      }else {
        var fileName = "信息表.xls";
      }
      console.log(this.currentId)
      // const fileName = "信息表.xls";
      const linkNode = document.createElement("a");

      linkNode.download = fileName; //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none";
      linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
      document.body.appendChild(linkNode);
      linkNode.click(); //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href); // 释放URL 对象
      document.body.removeChild(linkNode);
    },


    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      this.queryList();
    },
    openLocation(id) {
      this.$refs["CesiumViewer"].locationBuilding(id);
    },
    move(e) {
      let odiv = e.target; //获取目标元素

      let housestarty = e.clientY; //鼠标的初始位置
      let housestartx = e.clientX;

      let boxstartx = parseInt(odiv.style.right); //盒子初始位置
      let boxstarty = parseInt(odiv.style.top);

      //监听鼠标移动事件
      document.onmousemove = e => {
        let housemovex = housestartx - e.clientX; //鼠标移动距离
        let housemovey = housestarty - e.clientY;

        // 盒子初始位置 + 鼠标移动距离 得到盒子应该移动的距离
        let targetoffectx = boxstartx + housemovex;
        let targetoffecty = boxstarty - housemovey;

        //赋值给盒子
        odiv.style.right = targetoffectx + "px";
        odiv.style.top = targetoffecty + "px";
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
};
</script>
<style lang="less" scoped>
.mid {
  width: 0px;
  height: 0px;
  background-color: red;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 1000000;
  transition: all 2s;
}
.mid1 {
  width: 600px;
  height: 400px;
  background-color: red;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 1000000;
  transition: all 2s;
}
.mid2 {
  width: 600px;
  height: 400px;
  background:yellow;
  transition: all 2s;
}
.mapdiv {
  height: calc(91vh - 0px);
  width: 100vw;
  overflow: hidden;
}
.main {
  height: calc(91vh - 0px);

  .m-lr {
    height: calc(91vh - 0px);
    width: 22vw;
    background-color: #f2f9fd;
  }
}
/deep/.el-dialog__header {
      background-color: #01aaef!important;
      height: 20px!important;
      color: #ffffff!important;
}
// 左上echart盒子
#l-t-chartbox,
#l-b-chartbox,
#r-t-chartbox,
#r-b-chartbox {
  margin-top: 10%;
  padding-top: 8%;
  width: 100%;
  height: 40%;
  // background-color: rgb(172, 149, 149);
}
// 重置按钮和全屏按钮
.mapbox {
  position: relative;
  height: calc(91vh - 0px);
  width: 100vw;
}
.cesium-widget, /deep/ .cesium-widget canvas {
    width: 52%!important;
    height: 50%!important;
    touch-action: none!important;
}
.humanbox {
  background-color: #bdddfe;
  width: 186px;
  // height: 265px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px #f2f8fc;
  position: absolute;
  overflow: hidden;
  color: #7ea7c3;
  font-size: 13px;
  .naav {
    // display:inline-block;
    float: right;
    overflow: hidden;
    line-height: 28px;
    padding-right: 10px;
    color: #f2f8fc;
  }
  .bodyBox {
    background-color: rgb(242, 248, 252);
    margin-top: 28px;
    div {
      padding: 8px;
      font-size: 14px;
      color: #606266;
    }
  }
}
.clearLeftCard{
  width: 20px;
  height:100%;
  position: absolute;

  top: 40px;
  /*background-color: rgba(29, 44, 87, 0.664);*/
  background: url('../../../assets/images/bigData/shouqi1.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 10px 0 0 10px;
}
.leftCard1{
  left: 350px;
}
.leftCard2{
  left: 0;
}

.leftCard {
  position: absolute;
  z-index: 2;
  width: 350px;
  height: 100%;
  // background-color: rgb(194, 87, 87);
  left: 0;
  top: 40px;
  display: flex;
  flex-direction: column;
  .lCardBox1,
  .lCardBox2,
  .lCardBox3 {
    width: 100%;
    background-color: rgba(29, 44, 87, 0.664);
    border-radius: 10px 0 0 10px;
    margin-bottom: 15px;
    color: aliceblue;
    // padding: 0 8px;
    box-sizing: border-box;
    // height: 222px;
    position: relative;
    top: 0px;
    left: 0px;
  }
  // left card 1  nav
  .lCardBox1 {
    flex: 1.3;
    .active {
      .nav,
      .section {
        font-size: 13px;
        width: 100%;
        overflow: auto;
        display: flex;
        height: 34px;
        align-items: center;
        span {
          text-align: center;
        }
        span:nth-child(1) {
          flex: 1;
        }
        span:nth-child(2) {
          flex: 1;
        }
        span:nth-child(3) {
          flex: 0.6;
        }
      }
      // active name
      .nav {
        background-color: #306ab3;
        // margin: 0 -8px;
        width: calc(100% + 0px);
        // padding: 0 8px;
        box-sizing: border-box;
      }
    }
  }
}
.lCardBox1 {
  .search-list {
    display: flex;
    padding: 10px;
    .el-input .el-input__inner {
      background: transparent;
      border: 1px solid #0074ff;
      color: #fff;
    }
    .el-button {
      background: #0074ff;
      margin-left: 10px;
    }
  }
  .el-table {
    background: rgba(255, 255, 255, 0.4);
  }
  .el-table th,
  .el-table tr {
    background: #89bde5;
    color: #fff;
    font-weight: 400;
  }
  .el-table td,
  .el-table th {
    padding: 5px 0;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #76b0dd;
  }
  .el-dialog,
  .el-pager li {
    background: transparent;
    color: #fff;
  }
}
.nav2 {
  position: absolute;
  top: 0px;
  width: 100vw;
  // background-color: #fff;
  display: flex;
  align-items: flex-end;
  height: 34px;
  z-index: 5;
  // background-color: #5ca9fe;
  ul {
    height: 34px;
    display: flex;
    width: 100%;
    background-color: rgb(204, 213, 240);
    li {
      cursor: pointer;
      margin-top: 5px;
      width: 120px;
      height: 29px;
      background-color: #0064da;
      border-radius: 5px 5px 0 0;
      margin-right: 5px;
      color: #f2f9fd;
      text-align: center;
      line-height: 29px;
    }
  }
}
</style>